import { User } from '@choco-admin/types';
import { Button, Link as HeroLink } from '@heroui/react';
import React from 'react';
import { FiMessageSquare } from 'react-icons/fi';
import { Link } from 'react-router-dom';

import { CopyableIdChip } from '../../../../../components/CopyableIdChip';
import { UserStatus } from '../../../../../components/UserStatus';

interface UserProfileHeaderProps {
  user: User;
}

export const UserProfileHeader: React.FC<UserProfileHeaderProps> = ({
  user,
}) => {
  const chatsLink = {
    pathname: '/chats',
    search: `?search=${encodeURIComponent(
      user.id
    )}&type=all&enabledState=enabled`,
  };

  return (
    <div>
      <HeroLink
        as={Link}
        to="/users"
        color="primary"
        className="inline-flex items-center gap-2 mb-4"
      >
        ← Back to Users
      </HeroLink>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="title-large mb-2">{user.name || 'Unknown User'}</h1>
          <div className="flex items-center gap-2">
            <UserStatus
              hasRequestedToBeDeleted={user.hasRequestedToBeDeleted}
              pending={user.pending || false}
              size="sm"
            />
          </div>
          <div className="flex flex-wrap items-center gap-2 mt-2">
            <CopyableIdChip
              label="User ID"
              name="user ID"
              value={user.id}
              testId="user-id-copy"
            />
          </div>
        </div>
        <Button
          as={Link}
          to={chatsLink}
          variant="bordered"
          startContent={<FiMessageSquare size={16} />}
        >
          Show Chats
        </Button>
      </div>
    </div>
  );
};
